// extracted by mini-css-extract-plugin
module.exports = {"btn":"Button_btn__1Lkv5","btnPrimary":"Button_btnPrimary__g_WP5","btnSecondary":"Button_btnSecondary__1e7dV"};